module.exports = __webpack_public_path__ + "static/BT-desktop-9-b2bc9b4c8c0c11d4b35669c475b1bf6f.jpg";